import React, { useState } from 'react';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import CloseIcon from '../../../icons/close_dark.svg';
import styles from './modal_gate.module.scss';
import Clickable from '../../../components/clickable/Clickable';

const ModalGate = ({ data, onClose, assignmentData }) => {
    const [viewHistory, setViewHistory] = useState(false);
    const [selected, setSelected] = useState('arrival');
    const statusText = ['On Time', 'Delayed', 'Cancelled', 'Boarding'];
    const historyGateData = assignmentData?.length > 0 ? assignmentData.filter(item => item?.gateId === data?.gateId) : [];
    const arrival = historyGateData?.length > 0 ? historyGateData?.filter(arr => arr.data_arrival !== null)
    ?.sort((a, b) => (a.data_arrival > b.data_arrival ? 1 : -1)) : [];
    const departure = historyGateData?.length > 0 ? historyGateData?.filter(dep => dep.data_departure !== null)
    ?.sort((a, b) => (a.data_departure > b.data_departure ? 1 : -1)) : [];

    const detailsComponent = item => (
        <div className={styles.details}>
            <div className={styles.headings}>
                <span className={styles.airline_number}>{item?.departure_flight_number || item?.arrival_flight_number}</span>
                <span className={styles.airline_name}>{item?.airline}</span>
            </div>
            <div className={styles.main_details}>
                <div className={styles.timeline}>
                    <div className={styles.start_date}>{item?.dateStart && moment(item.dateStart).format('MMMM DD')}</div>
                    <div className={styles.start}>{item?.displayStart}</div>
                    <div className={styles.from_city_icao}>{item?.from_city_icao || '-'}</div>
                    <div className={styles.end_date}>{item?.dateEnd && moment(item.dateEnd).format('MMMM DD')}</div>
                    <div className={styles.end}>{item?.displayEnd}</div>
                    <div className={styles.to_city_icao}>{item?.to_city_icao || '-'}</div>
                    <div className={styles.arrow} />
                </div>
                <div className={styles.status} style={{ background: `${item?.backgroundColor}` || '' }}>
                    {statusText?.[item?.status || 0]}
                </div>
                <div />
                {item?.exception ? (
                    <div className={styles.rule}>
                        <div>
                            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_85_4941)">
                                 <path d="M10.5 2H8C8 1.46957 7.78929 0.960859 7.41421 0.585786C7.03914 0.210714 6.53043 0 6 0L2.5 0C1.96957 0
                                  1.46086 0.210714 1.08579 0.585786C0.710714 0.960859 0.5 1.46957 0.5 2L0.5 11.5C0.5 11.6326 0.552678 11.7598 0.646447
                                11.8536C0.740215 11.9473 0.867392 12 1 12C1.13261 12 1.25979 11.9473 1.35355 11.8536C1.44732 11.7598 1.5 11.6326 1.5
                                 11.5V6.5H5.5C5.5 7.03043 5.71071 7.53914 6.08579 7.91421C6.46086 8.28929 6.96957 8.5 7.5 8.5H10.5C11.0304 8.5 11.5391
                              8.28929 11.9142 7.91421C12.2893 7.53914 12.5 7.03043 12.5 6.5V4C12.5 3.46957 12.2893 2.96086 11.9142 2.58579C11.5391
                            2.21071 11.0304 2 10.5 2ZM1.5 5.5V2C1.5 1.73478 1.60536 1.48043 1.79289 1.29289C1.98043 1.10536 2.23478 1 2.5 1H6C6.26522
                            1 6.51957 1.10536 6.70711 1.29289C6.89464 1.48043 7 1.73478 7 2V4.5C7 4.76522 6.89464 5.01957 6.70711 5.20711C6.51957
                             5.39464 6.26522 5.5 6 5.5H1.5ZM11.5 6.5C11.5 6.76522 11.3946 7.01957 11.2071 7.20711C11.0196 7.39464 10.7652 7.5 10.5
                              7.5H7.5C7.23478 7.5 6.98043 7.39464 6.79289 7.20711C6.60536 7.01957 6.5 6.76522 6.5 6.5V6.429C6.92807 6.31848 7.30746
                               6.06923 7.57885 5.72022C7.85024 5.37121 7.99834 4.94211 8 4.5V3H10.5C10.7652 3 11.0196 3.10536 11.2071 3.29289C11.3946
                                3.48043 11.5 3.73478 11.5 4V6.5Z" fill="#7A7C7F" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_85_4941">
                                        <rect width="12" height="12" fill="white" transform="translate(0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span className="ml-1" style={{ color: ' #21252999' }}>Rule:</span>
                        </div>
                        <span>{item?.additional_info && (item?.additional_info?.rule?.restricted_airlines ? 'Airline' : 'Time') || ''}</span>
                    </div>
                ) : <div />}
            </div>
        </div>
    );
    return (
        <div className={styles.modal_container}>
            <div className={styles.headers}>
                <span className={styles.header_name}>Flight Details</span>
                <Clickable onClick={onClose} className={styles.closeIcon}>
                    <img
                    src={CloseIcon}
                    alt="closeIcon"
                    />
                </Clickable>
            </div>
            {viewHistory && (
                <div className={styles.navigation} style={{ marginLeft: '0px' }}>
                    <Clickable className={selected === 'arrival' ? styles.active : ''}
                        onClick={() => setSelected('arrival')}
                    >
                        <FormattedMessage id="gate.settings.arrival" defaultMessage="Arrival" />
                    </Clickable>
                    <Clickable className={selected === 'departure' ? styles.active : ''}
                        onClick={() => setSelected('departure')}
                    >
                        <FormattedMessage id="gate.settings.departure" defaultMessage="Departure" />
                    </Clickable>
                </div>
            )}
            {viewHistory ? (
                <div className={styles.viewHistory}>
                    {(selected === 'arrival' ? arrival : departure).map(item => (
                        detailsComponent(item)
                    ))}
                    {(selected === 'arrival' ? arrival : departure)?.length === 0 && (
                        <div className={styles.tableNoData}>
                            <FlightTakeoffIcon style={{ fontSize: '5rem', color: '#242e42b2' }} />
                            <h3 className="fw-bold text-muted">
                                <FormattedMessage id="no.flight.details" defaultMessage="No Flight Details" />
                            </h3>
                        </div>
                    )}
                </div>
            ) : (
                detailsComponent(data)
            )}
            <div className={styles.separator} />
            <Clickable className={styles.gate_history} onClick={() => setViewHistory(prev => !prev)}>
                {viewHistory? 'Hide Gate History' : 'View Gate History'}
            </Clickable>
        </div>
    );
};

export default ModalGate;
